<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <div class="page-title text-center">
        <h5>{{ title }}</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 main-blog mb-5">
        <div id="main" class="blog-wrapper">
          <div id="primary" class="site-content">
            <div id="content" role="main">
              <p *ngIf="loading; else AddBlogPost" style="text-align: center; padding: 10px 0;">
                <label>{{'common.loading' | translate}} ...</label>
              </p>
              <ng-template #AddBlogPost>
                <form *ngIf="form" class="form-blog-post comment-form" [formGroup]="form" novalidate (ngSubmit)="publishPostBlog()">
                  <div class="row">
                    <div class="col-md-12">
                      <label>{{'blog.title' | translate}}</label>
                      <input type="text" formControlName="title" class="form-control" />
                    </div>
                    <div class="col-md-12 mt-4">
                      <label>{{'common.category' | translate}}</label>
                      <select formControlName="categoryId" class="form-control">
                        <option *ngFor="let category of categories" [value]="category.id">{{ category.name }}</option>
                      </select>
                    </div>
                    <div class="col-md-12 mt-4">
                      <label>{{'blog.body' | translate}}</label>
                      <quill-editor
                        formControlName="body"
                        style="display: block; height: 300px;">
                      </quill-editor>
                    </div>
                    <div class="col-md-12 mt-4" style="padding-top: 50px;">
                      <label>{{'blog.feature_image' | translate}}</label>
                      <div>
                        <input type="file" formControlName="picture" (change)="onSelectedPicture($event)" />
                      </div>
                    </div>
                    <div class="col-md-12 mt-4">
                      <input type="hidden" formControlName="userId" />
                      <input type="hidden" formControlName="name" />
                      <button
                        [disabled]="form.invalid || submitting"
                        type="submit"
                        class="btn btn-success btn-md w-100">
                        {{'blog.publish' | translate}}
                      </button>
                      <span *ngIf="submitting" class="d-block text-center mt-2">
                        {{'common.submiting' | translate}} ...
                      </span>
                    </div>
                  </div>
                </form>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>